<template>
    <div>
        <div class="name">{{name}}</div>
        <b-table striped hover :items="list" class="table" :fields="fields">
        </b-table>
    </div>
</template>

<script>
    export default {
        name: 'StaticTable',
        props: ['list', 'name'],
        data() {
            return {
                fields: [
                    {
                        key: '名称',
                        label: '名称',
                        sortable: false
                    },
                    {
                        key: '数量',
                        sortable: false
                    },
                    {
                        key: '占比',
                        sortable: false
                    }
                ],
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .name{
        margin: 10px;
    }
    .table {
        width: 400px;
        margin: 5px;
    }
</style>
